import React, { useEffect, useState } from "react";
export default function Control({ controller, children }) {
    const [active, setActive] = useState(true);
    useEffect(() => {
        if (controller) {
            controller.setActive = setActive;
        }
    }, [controller]);
    return React.createElement(React.Fragment, null, active && children);
}
